import React, { useState } from "react";
import PropTypes from "prop-types";

import Tag from "ui/Tag";
import TagListDropdown from "ui/TagList/DropDown";

import Icon from "components/Icon";

/**
 * Отрисовывает список тегов с возможностью добавления новых
 *
 * @param {object[]} items - список отображаемых тегов
 * @param {object[]} availableTags - список тегов которые можно выбрать дополнительно
 * @param {func} onSelectAvailableItem - обработчик выбора нового тега
 * @param {func} onRemoveItem - обработчик клика на удалении тега
 * @param {boolean} viewOnly - позволяет блокировать добавление новых тегов
 */
const TagList = ({
    items,
    availableTags,
    onSelectAvailableItem,
    onRemoveItem,
    viewOnly,
}) => {
    const [show, setShow] = useState(false);

    const handleActivatorClick = () => {
        if (!show) {
            setShow(true);
        }
    };

    const preparedTags = items.map(({ text, type, value, ...other }) => {
        let tagFields = {
            text,
            type,
            value,
            ...other,
            icon: null,
            controls: null,
        };

        if (type) {
            switch (type) {
                case "alert":
                    tagFields.icon = (
                        <Icon type="alert" inheritColor inheritSize />
                    );
                    break;
            }
        }

        if (!viewOnly) {
            tagFields.controls = (
                <button
                    className="tag__remove-control"
                    type="button"
                    onClick={() => {
                        onRemoveItem({ value, ...other });
                    }}
                >
                    <Icon type="close" inheritColor inheritSize />
                </button>
            );
        }
        return tagFields;
    });

    return (
        <div className="tag-list">
            {preparedTags.map(({ customRender, ...tagFields }, index) =>
                customRender ? (
                    customRender(tagFields)
                ) : (
                    <Tag key={index} {...tagFields} />
                )
            )}

            {!viewOnly && availableTags.length > 0 && (
                <div className="tag-list__add">
                    <Tag
                        icon={<Icon type="plus" inheritSize />}
                        modificators={{
                            icon: ["m-size"],
                            container: ["pointer"],
                        }}
                        onClick={handleActivatorClick}
                    />
                    {show && (
                        <TagListDropdown
                            onSelectAvailableItem={onSelectAvailableItem}
                            availableTags={availableTags}
                            handleClickOutside={() => setShow(false)}
                            recalculateFix={preparedTags.length}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

TagList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            type: PropTypes.oneOf(["alert"]),
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            customRender: PropTypes.func,
        })
    ),
    availableTags: PropTypes.arrayOf(
        PropTypes.shape({
            content: PropTypes.any.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        })
    ),
    onSelectAvailableItem: PropTypes.func,
    onRemoveItem: PropTypes.func,
    viewOnly: PropTypes.bool,
};

export default TagList;
